// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HwvA","colBig":"styles_colBig__BswJU","colSmall":"styles_colSmall__1GfCY","shopifyNameWrapper":"styles_shopifyNameWrapper__2A-_E"};